import AsyncStorage from '@react-native-async-storage/async-storage';
import * as VernacularConfig from './VernacularConfig';
import fetch2 from '../fetch2';
import railsConfig from '../RailsConfig';

const config = {
  disableVernacular: true,
  availableLanguages: [VernacularConfig.defaultLanguage, VernacularConfig.hindi],
  selectedLanguage: VernacularConfig.defaultLanguage,
  translations: VernacularConfig.defaultTranslations,
};

export const getDefaultConfig = () => config;

export const getCachedConfig = async () => {
  const cachedConfigPromise = getConfigFromCache();
  const defaultConfigPromise = new Promise((resolve) => {
    setTimeout(() => {
      resolve(getDefaultConfig());
    }, 500);
  });
  return Promise.race([defaultConfigPromise, cachedConfigPromise]);
};

export const fetchConfig = async (code) => {
  const url = `${railsConfig.vernacularConfig}?selectedLang=${code}`;
  try {
    const response = await fetch2(url);
    const data = await response.json();
    if (data.status !== 'SUCCESS') {
      throw new Error('API Error');
    }
    await saveConfigToCache(data);
    return data;
  } catch (e) {
    return getDefaultConfig();
  }
};

const getConfigFromCache = async () => {
  try {
    const savedConfigStr = await AsyncStorage.getItem('rails_vernacular_config');
    const savedConfig = JSON.parse(savedConfigStr);
    if (!savedConfig) {
      return getDefaultConfig();
    }
    return savedConfig;
  } catch (e) {
    return getDefaultConfig();
  }
};

const saveConfigToCache = async (configData) => {
  await AsyncStorage.setItem('rails_vernacular_config', JSON.stringify(configData));
};
